import React from 'react';
import { Link } from 'react-router-dom';
import { FileText, ArrowLeft } from 'lucide-react';
import './LegalPages.css';

const Terms = () => {
  return (
    <div className="legal-page">
      <div className="container">
        <Link to="/" className="back-link">
          <ArrowLeft size={20} />
          <span>Înapoi la Pagina Principală</span>
        </Link>

        <div className="legal-header">
          <FileText size={48} />
          <h1>Termeni și Condiții</h1>
          <p className="legal-updated">Ultima actualizare: 25 August 2025</p>
        </div>

        <div className="legal-content">
          <section className="legal-section">
            <h2>1. Informații Generale</h2>
            <p>
              Prezentul document conține Termenii și Condițiile de utilizare a serviciilor oferite de
              <strong> MULTIPOWER TOUR SRL</strong>, companie înregistrată în România.
            </p>
            <div className="company-info">
              <h3>Date de Identificare:</h3>
              <ul>
                <li><strong>Denumire:</strong> MULTIPOWER TOUR SRL</li>
                <li><strong>Adresă:</strong> Jud. Botoșani, Mun. Dorohoi, Str. Zefirului, Nr.19</li>
                <li><strong>Telefon:</strong> +4-0740-824.224</li>
                <li><strong>Email:</strong> multipowertour@yahoo.com</li>
                <li><strong>Web:</strong> https://multipowertour.ro</li>
              </ul>
            </div>
          </section>

          <section className="legal-section">
            <h2>2. Acceptarea Termenilor</h2>
            <p>
              Prin accesarea și utilizarea serviciilor Multipower Tour, inclusiv aplicația mobilă și
              platforma web, confirmați că ați citit, înțeles și sunteți de acord să respectați prezentii
              Termeni și Condiții.
            </p>
          </section>

          <section className="legal-section">
            <h2>3. Servicii Oferite</h2>
            <p>Multipower Tour oferă servicii de transport public de pasageri, incluzând:</p>
            <ul>
              <li>Transport regulat pe rute urbane și interurbane</li>
              <li>Vânzare bilete și abonamente prin aplicație mobilă și platformă web</li>
              <li>Informații în timp real despre sosirea vehiculelor</li>
              <li>Planificarea călătoriilor și calcularea rutelor optime</li>
              <li>Servicii de notificare și alertă pentru pasageri</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>4. Conturi de Utilizator</h2>
            <h3>4.1 Crearea Contului</h3>
            <p>
              Pentru utilizarea completă a serviciilor, este necesară crearea unui cont. Datele furnizate
              trebuie să fie corecte, complete și actualizate.
            </p>
            <h3>4.2 Securitatea Contului</h3>
            <p>
              Utilizatorul este responsabil pentru păstrarea confidențialității datelor de autentificare
              și pentru toate activitățile desfășurate sub contul său.
            </p>
            <h3>4.3 Utilizatori Minori</h3>
            <p>
              Serviciile sunt destinate persoanelor cu vârsta de minimum 13 ani. Minorii sub 18 ani
              trebuie să obțină acordul părinților sau tutorilor legali.
            </p>
          </section>

          <section className="legal-section">
            <h2>5. Bilete și Plăți</h2>
            <h3>5.1 Achiziție Bilete</h3>
            <p>
              Biletele pot fi achiziționate prin aplicația mobilă, platforma web sau la bordul vehiculului,
              în conformitate cu tarifele afișate.
            </p>
            <h3>5.2 Metode de Plată</h3>
            <ul>
              <li>Card de credit/debit (Visa, Mastercard)</li>
              <li>Apple Pay</li>
              <li>Google Pay</li>
              <li>Numerar (doar la bord)</li>
            </ul>
            <h3>5.3 Validare Bilete</h3>
            <p>
              Biletele electronice trebuie validate la bordul vehiculului prin scanarea codului QR.
              Biletele nevalidate sunt considerate nevalabile.
            </p>
            <h3>5.4 Politica de Rambursare</h3>
            <ul>
              <li>Biletele neutilizate pot fi rambursate cu până la 24 de ore înainte de călătorie</li>
              <li>Se aplică o taxă administrativă de 10% din valoarea biletului</li>
              <li>Abonamentele pot fi anulate cu până la 7 zile de la achiziție pentru rambursare completă</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>6. Reguli de Călătorie</h2>
            <h3>6.1 Comportament</h3>
            <p>Pasagerii trebuie să:</p>
            <ul>
              <li>Dețină bilet valid pentru întreaga călătorie</li>
              <li>Respecte regulile de igienă și curățenie</li>
              <li>Nu fumeze în vehicul</li>
              <li>Nu consume băuturi alcoolice</li>
              <li>Respecte indicațiile personalului și șoferilor</li>
              <li>Nu deranjeze ceilalți pasageri</li>
            </ul>
            <h3>6.2 Bagaje</h3>
            <p>
              Fiecare pasager poate transporta gratuit un bagaj de mână cu dimensiuni maxime de
              55x40x20 cm. Bagajele voluminoase pot fi transportate în limita spațiului disponibil.
            </p>
            <h3>6.3 Sancțiuni</h3>
            <p>
              Nerespectarea regulilor poate duce la refuzul transportului, amendă sau suspendarea
              contului de utilizator.
            </p>
          </section>

          <section className="legal-section">
            <h2>7. Întârzieri și Modificări</h2>
            <p>
              Multipower Tour depune toate eforturile pentru respectarea orarelor publicate. Totuși,
              compania nu poate fi ținută responsabilă pentru întârzieri cauzate de:
            </p>
            <ul>
              <li>Condiții meteo nefavorabile</li>
              <li>Trafic intens sau accidente rutiere</li>
              <li>Situații de forță majoră</li>
              <li>Defecțiuni tehnice neprevăzute</li>
            </ul>
            <p>
              Compania își rezervă dreptul de a modifica sau anula curse cu notificare prealabilă,
              oferind alternative sau rambursare.
            </p>
          </section>

          <section className="legal-section">
            <h2>8. Limitarea Răspunderii</h2>
            <p>
              Multipower Tour nu răspunde pentru:
            </p>
            <ul>
              <li>Pierderea sau deteriorarea bunurilor personale</li>
              <li>Daune indirecte sau consecinționale</li>
              <li>Pierderi financiare datorate întârzierilor</li>
              <li>Erori în aplicația mobilă sau platformă</li>
            </ul>
            <p>
              Răspunderea companiei este limitată la valoarea biletului achiziționat.
            </p>
          </section>

          <section className="legal-section">
            <h2>9. Proprietate Intelectuală</h2>
            <p>
              Toate drepturile de proprietate intelectuală asupra aplicației, platformei web, logo-urilor,
              mărcilor și conținutului aparțin Multipower Tour SRL. Este interzisă copierea, reproducerea
              sau distribuirea fără acordul scris prealabil.
            </p>
          </section>

          <section className="legal-section">
            <h2>10. Modificarea Termenilor</h2>
            <p>
              Multipower Tour își rezervă dreptul de a modifica prezentii Termeni și Condiții în orice
              moment. Utilizatorii vor fi notificați cu privire la modificări prin email sau notificare
              în aplicație. Continuarea utilizării serviciilor după modificări constituie acceptarea
              noilor termeni.
            </p>
          </section>

          <section className="legal-section">
            <h2>11. Legislație Aplicabilă</h2>
            <p>
              Prezentii Termeni și Condiții sunt guvernați de legile României. Orice dispută va fi
              soluționată în mod amiabil sau, în caz contrar, de instanțele competente din România.
            </p>
          </section>

          <section className="legal-section">
            <h2>12. Contact</h2>
            <p>
              Pentru întrebări sau clarificări privind prezentii Termeni și Condiții, ne puteți contacta:
            </p>
            <div className="contact-box">
              <p><strong>MULTIPOWER TOUR SRL</strong></p>
              <p>Str. Zefirului, Nr.19, Mun. Dorohoi, Jud. Botoșani</p>
              <p>Telefon: <a href="tel:+40740824224">+4-0740-824.224</a></p>
              <p>Email: <a href="mailto:multipowertour@yahoo.com">multipowertour@yahoo.com</a></p>
              <p>Web: <a href="https://multipowertour.ro">https://multipowertour.ro</a></p>
            </div>
          </section>

          <div className="legal-footer">
            <p>
              Prin utilizarea serviciilor Multipower Tour, confirmați că ați citit și înțeles
              prezentii Termeni și Condiții și că sunteți de acord să îi respectați.
            </p>
          </div>
        </div>

        <div className="legal-navigation">
          <Link to="/confidentialitate" className="legal-nav-link">
            Politica de Confidențialitate →
          </Link>
          <Link to="/gdpr" className="legal-nav-link">
            GDPR →
          </Link>
          <Link to="/cookies" className="legal-nav-link">
            Politica Cookies →
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Terms;
